<template>
  <section id="contact" class="py-5 bg-success bg-gradient text-white text-center">
    <div class="container">
      <h2>Ingin Melakukan Konsultasi Dengan MUI?</h2>
      <p>Silahkan dapat menghubungi  kamu di nomor berikut.</p>
      <a href="mailto:info@example.com" class="btn btn-light btn-lg"
        >Contact Us</a
      >
    </div>
  </section>
</template>

<script>
export default {
  name: "SectionCall",
};
</script>
